// Action-mode sidebar chips for the admin chat surface (H.3.4a). Each chip is
// a preset slash-command. Chips without args submit immediately; chips with
// args populate the input bar instead. Mirrors the outreach SidebarChips with
// the admin chip set (Review / Ops).

type Chip = { label: string; slash: string };
type Section = { title: string; chips: Chip[] };

const SECTIONS: Section[] = [
  {
    title: 'Review',
    chips: [
      { label: 'Officer queue', slash: '/queue' },
      { label: 'KYC review', slash: '/kyc' },
    ],
  },
  {
    title: 'Ops',
    chips: [
      { label: 'Scan invariants', slash: '/scan' },
      { label: 'Seed event', slash: '/seed' },
    ],
  },
];

type Props = {
  // Chips with no args submit immediately; chips with args populate the input.
  onChipSubmit: (slash: string) => void;
  onChipPopulate: (slash: string) => void;
};

const ARG_REQUIRED = new Set(['/queue', '/kyc', '/seed']);

export function SidebarChips({ onChipSubmit, onChipPopulate }: Props) {
  return (
    <nav className="space-y-6 text-sm">
      {SECTIONS.map((s) => (
        <div key={s.title}>
          <h3 className="text-[11px] font-semibold uppercase tracking-wider text-foreground-mute px-2 mb-2">
            {s.title}
          </h3>
          <div className="space-y-0.5">
            {s.chips.map((c) => (
              <button
                key={`${s.title}-${c.slash}-${c.label}`}
                type="button"
                onClick={() =>
                  ARG_REQUIRED.has(c.slash)
                    ? onChipPopulate(`${c.slash} `)
                    : onChipSubmit(c.slash)
                }
                className="block w-full text-left px-2 py-1 rounded text-xs text-foreground-mute hover:bg-muted hover:text-foreground"
                data-testid={`chip-${c.slash.slice(1)}`}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </nav>
  );
}
